import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const RecentSwimsContext = createContext(null);

export const RecentSwimsProvider = ({ children }) => {
  const [swims, setSwims] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const requestRef = useRef(null);

  const loadRecentSwims = useCallback(async ({ refresh = false } = {}) => {
    if (!refresh && loaded) return;
    if (requestRef.current) return requestRef.current;

    setLoading(true);
    setError(null);
    const request = httpsCallable(functions, 'getRecentSwims')()
      .then((result) => {
        setSwims(result.data.swims || []);
        setLoaded(true);
      })
      .catch((loadError) => {
        console.error('Failed to load recent swims:', loadError);
        setError('Failed to load swim data.');
      })
      .finally(() => {
        requestRef.current = null;
        setLoading(false);
      });

    requestRef.current = request;
    return request;
  }, [loaded]);

  return (
    <RecentSwimsContext.Provider value={{
      swims,
      loading,
      error,
      loadRecentSwims
    }}>
      {children}
    </RecentSwimsContext.Provider>
  );
};

export const useRecentSwims = () => {
  const context = useContext(RecentSwimsContext);
  if (!context) throw new Error('useRecentSwims must be used within RecentSwimsProvider.');
  return context;
};
